import styled from 'styled-components';

import { rem, mediaUp } from 'approot/shared/style';
import {
  grey1,
  grey4,
  grey7,
  grey10,
} from 'approot/shared/styles/colours.style';
import {
  fontWeightNormal,
  fontSize16,
  font16,
  fontSize18LineHeight,
  Heading20,
  font30,
  fontWeightMedium,
  Heading18,
  LinkStyled,
  PStyled,
} from 'approot/shared/styles/typography.style';
import {
  marginCss,
  MarginProps,
  spacing12,
  spacing16,
  spacing24,
  spacing4,
} from 'approot/shared/styles/spacing.style';
import { LayoutContentStyled } from 'approot/shared/layout/layout.styles';
import { imageTransition } from 'approot/shared/images/images.style';
import { borderRadius16 } from 'approot/shared/styles/borders.style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';

type ContentPageSectionProps = {
  marginBottom?: number;
};
export const ContentPageSection = styled.section<ContentPageSectionProps>`
  padding-bottom: ${({ marginBottom = spacing24 }) => rem(marginBottom)};
`;

export const ContentPageEditorButtons = styled.div`
  display: flex;
  -webkit-box-pack: end;
  justify-content: flex-end;

  button {
    margin-left: ${rem(spacing16)};
  }
`;

export const ContentPageHeading18 = styled(Heading18).attrs({
  as: 'h2',
})``;

export const ContentPageHeading20 = styled(Heading20).attrs({
  as: 'h2',
  'data-selector': 'content-section-title',
})`
  flex-grow: 1;
`;

export const ContentPageSubheading = styled.h3`
  font-size: ${rem(fontSize16)};
  font-weight: ${fontWeightNormal};
  line-height: ${rem(fontSize18LineHeight)};
  color: ${grey7};
`;

export const ContentDivider = styled.hr.attrs({
  'aria-hidden': true,
})<MarginProps>`
  ${() =>
    marginCss({
      $marginBottom: 40,
      $marginTop: 0,
    })}

  border-top-color: ${grey4};
`;

export const ContentPageLink = styled(LinkStyled)`
  ${font16}
  display: inline-block;
  margin-bottom: ${rem(spacing16)};
`;

export const ContentPageHeaderLayout = styled(LayoutContentStyled).attrs({
  withMaxWidth: true,
})`
  background-color: ${grey1};
  padding-top: ${rem(spacing24)};
  padding-bottom: ${rem(spacing4)};
`;

export const ContentPageContentLayout = styled(LayoutContentStyled).attrs({
  withMaxWidth: true,
})`
  padding-top: ${rem(spacing24)};
`;

type ContentPageMastheadTitleProps = {
  marginBottom?: number;
};
export const ContentPageMastheadTitle = styled.h1<
  ContentPageMastheadTitleProps
>`
  ${font30}
  color: ${grey10};
  font-weight: ${fontWeightMedium};
  margin-bottom: ${({ marginBottom = spacing12 }) => rem(marginBottom)};
`;

export const ContentPageMastheadDetails = styled.div`
  ${baseFlexCss}
  gap: ${rem(spacing16)};
  flex-wrap: wrap;
`;

export const ContentPageSectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${rem(spacing24)};
`;

export const ContentPageLayout = styled(LayoutContentStyled).attrs({
  withMaxWidth: true,
})``;

export const ContentPageText = styled(PStyled)``;

export const ContentPageHeaderImageWrapper = styled.div`
  background-color: ${grey4};
  border-radius: ${rem(borderRadius16)};
  height: ${rem(200)};
  overflow: hidden;
  position: relative;

  ${mediaUp.sm`
    height: ${rem(240)};
  `}

  ${mediaUp.lg`
    height: ${rem(320)};
  `}
`;

type ContentPageHeaderImageProps = {
  imageUrl?: string;
  imageHasLoaded: boolean;
};
export const ContentPageHeaderImage = styled.div.attrs<
  ContentPageHeaderImageProps
>(({ imageUrl }) => ({
  style: {
    backgroundImage: imageUrl ? `url(${imageUrl})` : '',
  },
}))<ContentPageHeaderImageProps>`
  ${imageTransition}
  background-size: cover;
  background-position: center center;
  height: 100%;
  opacity: ${({ imageHasLoaded }) => (imageHasLoaded ? '1' : '0')};
`;

export const ContentPageMaxTextWidthContainer = styled.div`
  max-width: ${rem(700)};
`;
